<template>
  <div
    :class="cx('sticky top-0 z-50 flex h-[3.75rem] w-full items-center border-b border-[#EEEEEE] bg-[--color-neutral-white] px-[16px] py-[12px]', $attrs.class)"
  >
    <template v-if="authStore.isUserLogged">
      <div class="top-nav-wrapper mx-auto flex w-full items-center justify-between gap-[8px]">
        <TopbarToogleButton class="md:hidden" @on-toggle="toggleSidebar" />
        <KeywordSearchbar :quota="keywordToolQuota" class="pr-[20px]" />
        <RefreshDataButton />
      </div>
    </template>
    <template v-else>
      <div class="mx-auto flex w-full max-w-[1440px] items-center justify-between">
        <TopbarToogleButton class="md:hidden" @on-toggle="toggleSidebar" />
        <div class="flex gap-[24px]">
          <a :href="homeURL">
            <img
              :src="logoPath"
              class="hidden h-[25px] items-center gap-[24px] md:flex"
              alt="Erank Logo"
            >
          </a>
          <TopbarLinks
            class="hidden md:flex"
            :links="[
              {link: 'https://help.erank.com/features', label: 'Features'},
              {link: 'https://help.erank.com', label: 'Resources'},
              {link: plansLink, label: 'Plans & Pricing'},
            ]"
          />
        </div>
        <div class="flex gap-[18px]">
          <RouterLink :to="{name: 'login.entry'}" class="v3-h6-regular-400-line-height-1.5 flex items-center text-[var(--v3-theme-highlighttextcolor)]">
            Log In
          </RouterLink>
          <RouterLink :to="{name: 'registration.entry'}" class="flex h-control items-center justify-center whitespace-nowrap rounded-[28px] border-[--v3-button-buttonborder] bg-[--v3-button-buttonbg] px-5 text-[--v3-button-buttontextcolor]">
            Start for Free
          </RouterLink>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { useAuthStore } from '@/common/stores/auth';
import { useSubscriptionStore } from '@/common/stores/subscription';
import { cx } from '@/helpers/cva';
import TopbarToogleButton from '@/modules/layout/components/atoms/TopbarToggleButton';
import TopbarLinks from '@/modules/layout/components/molecules/TopbarLinks';
import KeywordSearchbar from '@/modules/layout/components/organisms/KeywordSearchbar';
import RefreshDataButton from '@/modules/layout/components/organisms/RefreshDataButton';
import { useSidebarStore } from '@/modules/layout/stores/sidebar';
import { useTopbarStore } from '@/modules/layout/stores/topbar';

const sidebarStore = useSidebarStore();
const authStore = useAuthStore();
const topbarStore = useTopbarStore();
const { quotas } = storeToRefs(useSubscriptionStore());
const { hasShopConnected } = storeToRefs(authStore);
const homeURL = 'https://erank.com';
const logoPath = '/img/logo.svg';

if (hasShopConnected.value) {
  topbarStore.getLastRefreshTime();
}
const keywordToolQuota = computed(() => `${quotas.value.keyword_tool.current_usage}/${quotas.value.keyword_tool.feature_quota}`);

const toggleSidebar = () => {
  sidebarStore.collapsed = !sidebarStore.collapsed;
};

const plansLink = computed(() => `${import.meta.env.VITE_ERANK_APP_MEMBERS_URL}/plans`);
</script>

<style lang="scss" scoped>
.top-nav-wrapper {
  container-type: inline-size;
}
</style>
